// extracted by mini-css-extract-plugin
module.exports = {"container":"actualities_header-module--container--2ioyS","background":"actualities_header-module--background--3f2TO","title":"actualities_header-module--title--uy0hi"};